import { render, staticRenderFns } from "./SiblingSelection.vue?vue&type=template&id=4b813cb5&scoped=true&"
import script from "./SiblingSelection.vue?vue&type=script&lang=js&"
export * from "./SiblingSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b813cb5",
  null
  
)

export default component.exports